<template>
  <div id="app">
    <!-- 预加载器 -->
    <div v-show="isLoading" class="preloader">
      <div class="preloader-inner">
        <div class="preloader-icon">
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    
    <!-- 导航栏 -->
    <HeaderNav />
    
    <!-- 路由出口 -->
    <router-view />
    
    <!-- 页脚 -->
    <FooterSection />

    <ConsentManager />
    
    <!-- 返回顶部按钮 -->
    <div class="bottomtotop" v-show="showBackToTop" @click="scrollToTop">
      <i class="fa fa-angle-up"></i>
    </div>
  </div>
</template>

<script>
import HeaderNav from './components/HeaderNav.vue'
import FooterSection from './components/FooterSection.vue'
import ConsentManager from './components/ConsentManager.vue'
import { initMainFeatures, shouldShowBackToTop, scrollToTop } from './utils/main.js'

export default {
  name: 'App',
  components: {
    HeaderNav,
    FooterSection,
    ConsentManager
  },
  data() {
    return {
      isLoading: true,
      showBackToTop: false
    }
  },
  mounted() {
    this.initPreloader()
    this.initMagnificPopup()
    
    // 初始化主要功能
    initMainFeatures();
    
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    initPreloader() {
      // Vue实现的预加载器
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
      
      // 监听页面加载完成
      window.addEventListener('load', () => {
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      })
    },
    initMagnificPopup() {
      // Vue实现的图片弹窗功能
      this.$nextTick(() => {
        const popupLinks = document.querySelectorAll('.popup-link')
        popupLinks.forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault()
            const imgSrc = link.getAttribute('href')
            this.showImagePopup(imgSrc)
          })
        })
      })
    },
    showImagePopup(imgSrc) {
      // 创建简单的图片弹窗
      const overlay = document.createElement('div')
      overlay.className = 'image-popup-overlay'
      overlay.innerHTML = `
        <div class="image-popup-content">
          <img src="${imgSrc}" alt="Popup Image">
          <button class="popup-close">&times;</button>
        </div>
      `
      
      document.body.appendChild(overlay)
      
      // 关闭弹窗
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay || e.target.classList.contains('popup-close')) {
          document.body.removeChild(overlay)
        }
      })
    },
    handleScroll() {
      this.showBackToTop = shouldShowBackToTop();
      if (this.showBackToTop) {
        this.showScrollMouse = false;
      }
    },
    scrollToTop() {
      scrollToTop();
    }
  }
}
</script>

<style>
/* App级别的样式已在global.css中定义 */

/* 预加载器样式 */
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preloader-inner {
  text-align: center;
}

.preloader-icon {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.preloader-icon span {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #007bff;
  animation: preloader-animation 1.2s linear infinite;
}

.preloader-icon span:nth-child(1) {
  left: 8px;
  animation-delay: 0s;
}

.preloader-icon span:nth-child(2) {
  left: 8px;
  animation-delay: -0.6s;
}

@keyframes preloader-animation {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1);
  }
}

/* 图片弹窗样式 */
.image-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.image-popup-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  cursor: default;
}

.image-popup-content img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 8px;
}

.popup-close {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 40px;
  height: 40px;
  background: #fff;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.popup-close:hover {
  background: #f0f0f0;
}

/* Video styles */
#homeVideoDesktop {
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0;
  height: auto;
  object-fit: cover;
}

.video-slide {
  display: none;
}

#mobileSlide {
  display: block;
}

#homeVideoMobile {
  width: 100%;
  height: auto;
}

@media (max-width: 700px) {
  .video-slide {
    display: none;
  }
  #mobileSlide {
    display: block;
  }
}

@media (min-width: 701px) {
  .video-slide {
    display: block;
  }
  #mobileSlide {
    display: none;
  }
}

/* 轮播图片全屏显示优化 */
.swiper-container {
  height: 100vh;
  min-height: 600px;
}

.swiper-slide {
  height: 100%;
}

.hero-area {
  height: 100%;
  width: 100%;
  position: relative;
}

.main-img {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.main-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.main-img picture {
  height: 100%;
  width: 100%;
  display: block;
}

/* 确保标题在图片上方正确显示 */
.mian-title-plus,
.mian-title {
  z-index: 10;
  position: absolute;
}

@media (max-width: 768px) {
  .swiper-container {
    height: 29vh;
    min-height: 250px;
  }
  .swiper-pagination-bullet{
		width: 50px !important;
		height: 5px !important;
	}
}


/* 滚动鼠标提示样式 */
.scroll-mouse {
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  text-align: center;
}

.mouse {
  width: 25px;
  height: 40px;
  border: 2px solid #fff;
  border-radius: 15px;
  margin: 0 auto 10px;
  position: relative;
}

.wheel {
  width: 3px;
  height: 8px;
  background-color: #fff;
  border-radius: 2px;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  animation: scroll-wheel 2s infinite;
}

.m_scroll_arrows {
  display: block;
  width: 5px;
  height: 5px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  margin: 0 auto 3px;
  transform: rotate(45deg);
  animation: scroll-arrows 2s infinite;
}

.m_scroll_arrows.unu {
  animation-delay: 0.1s;
}

.m_scroll_arrows.doi {
  animation-delay: 0.2s;
}

.m_scroll_arrows.trei {
  animation-delay: 0.3s;
}

@keyframes scroll-wheel {
  0% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
}

@keyframes scroll-arrows {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* 移动端滚动提示适配 */
@media (max-width: 768px) {
  .scroll-mouse {
    bottom: 30px;
  }
}
</style>
